import React from "react";
import {Insights} from "./insights";

export const Home = () => {
    return (
        <Insights/>
    ) ;
};

